export const ALIGNMENT_TYPE_FORM_DESCRIPTION =
    "Use stakeholder alignment to indicate whether stakeholders are supporters, "
    + "neutral, or detractors of your organization's and your issues. "
    + "Customize these alignments to match your organization's stakeholder mapping terminology."

// The default Alignments provided to every Organization have the following values.
// We can use this knowledge to select the correct AlignmentType, even if it's label is changed.
export const defaultAlignmentValues = {
    supporter: 10,
    neutral: 0,
    detractor: -10
}
